import { displayCoordinatorConfig } from "@crunchdao/shared-cli";
import { BaseCommand } from "@crunchdao/shared-cli";
import { getCoordinatorConfig, getCoordinatorConfigAddress } from "@crunchdao/sdk";

export class GetConfigCommand extends BaseCommand {
  async execute(): Promise<void> {
    try {
      // Check if JSON output is requested
      if (this.resolvedOptions.output === "json") {
        const coordinatorConfig = await getCoordinatorConfig(this.program);
        const configAddress = getCoordinatorConfigAddress(this.program);

        // Format for JSON output
        const output = {
          address: configAddress.toBase58(),
          bump: coordinatorConfig.bump,
          coordinatorAdminAuthority: coordinatorConfig.coordinatorAdminAuthority.toBase58(),
          usdcMint: coordinatorConfig.usdcMint.toBase58(),
          burnMarginPercentage: coordinatorConfig.burnMarginPercentage,
          foundationMarginPercentage: coordinatorConfig.foundationMarginPercentage,
          claimExpirySeconds: coordinatorConfig.claimExpirySeconds.toString(),
          foundationWallet: coordinatorConfig.foundationWallet.toBase58(),
          proposedCoordinatorAdminAuthority: coordinatorConfig.proposedCoordinatorAdminAuthority
            ? coordinatorConfig.proposedCoordinatorAdminAuthority.toBase58()
            : null,
        };

        this.output(output);
      } else {
        // Use the existing table display
        await displayCoordinatorConfig(this.program, this.network);
      }
    } catch (error) {
      this.handleError(error);
    }
  }
}
